{
  "bool": {
    "enum": ["bool"]
  },
  "cstring": {
    "title": "cstring",
    "type": "array",
    "items": [
      {
        "enum": ["cstring"]
      },
      {
        "type": "object",
        "properties": {
          "encoding": {
            "type": "string"
          }
        },
        "additionalProperties": false,
        "required": []
      }
    ],
    "additionalItems": false
  },
  "void": {
    "enum": ["void"]
  }
}
